import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';

@Component({
  selector: 'atx-modal-footer',
  templateUrl: './modal-footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ModalFooterComponent {
  @HostBinding('class.modal-footer')
  public modalFooterClass = true;
}
